import React from 'react'
import { Container, Typography } from '@mui/material'

interface PageTitleProps {
  title: string
}

export const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
  return (
    <Container maxWidth='xl'>
      <Typography variant='h4' component='h2' gutterBottom>
        {title}
      </Typography>
    </Container>
  )
}
